<div *ngIf="isDesktop" class="container">

    <span class="servicios-title">Servicios Disponibles</span>
    <div class="servicios-container">
        <div *ngFor="let item of serviciosDetalle" class="servicios-item"  [ngClass]="{'seleccionado': selectedSkuIds.includes(item.servicioSkuId)}" (click)="toggleSku(item.servicioSkuId)">

            <img src="{{item.img}}"/>
            <span style="font-weight: bold; font-size: 13px;">{{item.label}}</span>
            <span class="badge me-1 fs-14px" [ngClass]="{'bg-danger': item.cantidadDisponible ===  0, 'bg-green': item.cantidadDisponible ===  item.cantidadTotal, 'bg-warning': item.cantidadDisponible > 0 && item.cantidadDisponible < item.cantidadTotal}">{{item.cantidadDisponible}} / {{item.cantidadTotal}}</span>
        </div>
    </div>
</div>
<mat-dialog-content class="py-1" [ngClass]="{'max-timeline': isDesktop}">
	@if(historial.length>0){
		<div class="timeline">
			<div *ngFor="let estatus of historial; let idx = index" class="timeline-item pb-0">
				<div class="timeline-time">
					<span class="date">{{getDate(estatus.fecha)}}</span>
					<span class="time">{{getTime(estatus.fecha)}}</span>
				</div>
				<div class="timeline-icon">
					<a href="javascript:;">&nbsp;</a>
				</div>
				<div class="timeline-content">
					<div class="timeline-header pb-0">
						<div class="username text-center">
							<a href="javascript:;"><b>{{estatus.descripcion}}</b></a>
							<!-- <div class="text-muted fs-12px">8 mins <i class="fa fa-globe-americas opacity-5 ms-1"></i></div> -->
						</div>
					</div>	
					<div class="timeline-body">
						<!-- timeline-post -->
						<div class="d-flex flex-row w-100 align-items-start justify-content-between mb-3">
							<div>
								<div class="userimage"><img class="{{estatus.iconClass}}" alt="" /></div>
							</div>
							<div class="d-flex flex-column mb-2" style="min-width: 50%;">
								<span class="fs-12px text-transform-uppercase"><b>Usuario:</b> {{estatus.usuario}}</span>
								<!-- <span class="fs-12px text-transform-uppercase"><b>Cliente:</b> {{estatus.cliente}}</span> -->
								<span class="fs-12px text-transform-uppercase"><b>Sucursal:</b> {{estatus.sucursal}}</span>
							</div>
						</div>
						<div class="mt-1">
							<div class="mb-2">Evidencias Fotográficas</div>
							
							<div class="scroll-wrapper">
								<button class="btn btn-primary scroll-btn left" (click)="scrollLeft(idx)">&#9664;</button>

								<div class="custom-images-container gx-1" #scrollContainer>
									<div *ngFor="let img of estatus.filespaths; let i = index" class="col-5">
										<img [src]="img" (click)="abrirImagen(estatus, i)" alt="" class="mw-100 d-block" style="width: 180px; max-height: 100px;" />
									</div>
								</div>

								<button class="btn btn-primary scroll-btn right" (click)="scrollRight(idx)">&#9654;</button>
							</div>

						</div>
					</div>
                </div>
			</div>
		</div>
	}@else{
		<p class="text-center w-100 py-5">No se encontraron registros históricos del Plan Protection</p>
	}
	<br>
</mat-dialog-content>
